/// <amd-module name="Artifacts/Connect/components/Common" />
import * as Res from "Artifacts/Connect/Resources";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import {
  CopyableTextField,
  ICopyableTextFieldProps,
} from "Artifacts/Root/protocols/components/CopyableTextField";
import * as React from "react";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Card } from "VSSUI/Card";
import { MessageBar } from "VSSUI/MessageBar";
import { css } from "VSSUI/Util";

export const CopyableCode: React.FC<ICopyableTextFieldProps> = (props) => (
  <CopyableTextField
    {...props}
    className={css("monospaced-m", props.className)}
    buttonProps={{ tooltipProps: { text: Res.CopyToClipboard }, ariaLabel: props.ariaLabel }}
  />
);

interface IDetailsCardTitleProps {
  text: string;
  ariaLevel?: number;
}

export const DetailsCard: React.FC<{ title: IDetailsCardTitleProps }> = ({ title, children }) => (
  <Card
    className="card"
    titleProps={{ text: title.text, className: "font-weight-semibold", ariaLevel: title.ariaLevel }}
  >
    <div className="flex-grow card-content">{children}</div>
  </Card>
);

export const PublishDetailsCard: React.FC<{ feed: ICombinedFeedView }> = ({ feed, children }) => {
  const parts = feed.name.split("@");
  if (parts.length === 2) {
    return (
      <DetailsCard title={{ text: Res.PublishPackages, ariaLevel: 3 }}>
        <MessageBar className="messagebar">
          <FormatComponent format={Res.PublishNotSupported}>
            @{parts[1]}
            {parts[0]}
          </FormatComponent>
        </MessageBar>
      </DetailsCard>
    );
  } else {
    return (
      <DetailsCard title={{ text: Res.PublishPackages, ariaLevel: 3 }}>{children}</DetailsCard>
    );
  }
};

/**
 * WidthBreakpoint renders child elements only if inner width is less than provided as widthLessThan prop
 */
export const WidthBreakpoint: React.FC<{ widthLessThan: number }> = ({
  children,
  widthLessThan,
}) => {
  const [width, setWidth] = React.useState<number>(window.innerWidth);

  React.useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  });

  return <>{width < widthLessThan ? children : ""}</>;
};
